<template>
  <a-modal
          title="农产品分类详情"
          okText="保存"
          cancelText="取消"
          width="800px"
          :visible="visible"
          :confirm-loading="confirmLoading"
          @ok="handleOk"
          @cancel="handleCancel"
  >
    <a-form-model ref="ruleForm" :model="formState" :rules="rules" :label-col="{span:8}" :wrapper-col="{span:16}">
      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="编号" prop="code">
            <a-input v-model="formState.code"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="是否参与判定标准" prop="needJudge">
            <a-radio-group v-model="formState.needJudge">
              <a-radio value="是">
                是
              </a-radio>
              <a-radio value="否">
                否
              </a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="中文名称" prop="cn">
            <a-input v-model="formState.cn"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="英文名称" prop="en">
            <a-input v-model="formState.en"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="拉丁名称" prop="ld">
            <a-input v-model="formState.ld"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="中文别名" prop="nick">
            <a-input v-model="formState.nick"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="GEMS编码" prop="gems">
            <a-input v-model="formState.gems"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="FOODEX_2编码" prop="foodex2">
            <a-input v-model="formState.foodex2"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}"  label="照片" prop="zhaopian">
            <a-ext-upload v-model="formState.zhaopian"></a-ext-upload>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="描述" prop="remark">
            <a-input v-model="formState.remark"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="排序" prop="orderby">
            <a-input v-model="formState.orderby"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="所属行业" prop="hangye">
            <a-ext-local-dic-select dic-key="HangYe" v-model="formState.hangye"></a-ext-local-dic-select>
          </a-form-model-item>
        </a-col>
      </a-row>

    </a-form-model>

  </a-modal>
</template>

<script>

import AExtLocalDicSelect from '../../../components/AntDesignExt/All/AExtLocalDicSelect'
import AExtUpload from '../../../components/AntDesignExt/All/AExtUpload'
import {addorUpdateStdProduceItem as saveApi,getStdProduceItemById as initApi} from '../../../api/api'
import {FormRules} from 'antd-form-rules';
export default {
    name: "FormModel",
    components:{
        AExtLocalDicSelect,AExtUpload},
    props:{
        visible:{
            type:Boolean,
            default:false
        },
        param:{
            type:Object,
            default: ()=>{
                return {}
            }
        }
    },
    data() {
        return {
            confirmLoading: false,
            formState: {
                code:'',
                needJudge:'',
                cn:'',
                en:'',
                ld:'',
                nick:'',
                gems:'',
                foodex2:'',
                remark:'',
                orderby:'',
                hangye:'',
                zhaopian:{}
            },
            rules: {
                code: FormRules.withName('编号').string(1, 200).isRequired().create(),
                needJudge: FormRules.withName('是否参与标准').string(1, 50).isRequired().create(),
                cn: FormRules.withName('中文名').string(1, 200).isRequired().create(),
            },

        };
    },
    created(){
        this.initForm();
    },
    methods: {
        initForm(){
            this.formState.belongId=this.param.belongId;
            this.formState.ppath=this.param.ppath;
        },
        handleOk(e) {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.confirmLoading = true;
                    saveApi(this.formState).then((result=>{
                        this.confirmLoading = false;
                        this.$emit("addStdProduceModalClose",true)
                        this.$emit("update:visible",false)
                    })).catch(()=>{
                        this.confirmLoading = false;
                    });
                } else {
                    return false;
                }
            });
        },
        handleCancel(e) {
            this.$emit("update:visible",false)
        },

    },
}
</script>

<style scoped lang="scss">

  /deep/ .ant-modal-body{
    /*height: 60vh;*/
    /*overflow-y: scroll;*/
  }

</style>